export const fontWeights = {
  regular: 400,
  semibold: 600,
};
